
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"12","viewBox":"0 0 16 12","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.7657 0.234328C15.4533 -0.0781094 14.9468 -0.0781094 14.6343 0.234328L5.04983 9.81892L1.3657 6.1348C1.0533 5.82236 0.546797 5.82239 0.234328 6.1348C-0.0781094 6.4472 -0.0781094 6.9537 0.234328 7.26614L4.48414 11.5159C4.79645 11.8283 5.30333 11.8281 5.61552 11.5159L15.7657 1.3657C16.0781 1.0533 16.0781 0.546766 15.7657 0.234328Z"}})])
          )
        }
      }
    